// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logoimg from '../../Assets/Images/FutureInvoice.png';
import scan from '../../Assets/Images/FutureInvoiceScan.jpeg';
import stamp from '../../Assets/Images/StampFutureinfosys.png';
import Header from '../../Components-2/Header/Header';
import Sidebar1 from '../../Components-2/Sidebar1';
import { getApi } from '../Admin Master/Area Control/Zonemaster/ServicesApi';
import { FiFileText } from "react-icons/fi";
// import { IoLocationSharp } from "react-icons/io5";
import { FaPhone } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";
// import { TfiWorld } from "react-icons/tfi";
import { IoDocumentText } from "react-icons/io5";
import { BsQrCodeScan } from "react-icons/bs";
import { RiBankFill } from "react-icons/ri";
import { MdAccountBalance } from "react-icons/md";
import { LuBanknote } from "react-icons/lu";
import { RiSecurePaymentFill } from "react-icons/ri";
import { MdOutlineAccountCircle } from "react-icons/md";
import { IoCheckmarkDoneCircle } from "react-icons/io5";
import { FaStamp } from "react-icons/fa6";
import UPI from "../../Assets/Images/UpiImageFuture.png";
import { ToWords } from "to-words";
import html2pdf from "html2pdf.js";


function FutureInvoicePdf() {

    const toWords = new ToWords({
        localeCode: "en-IN", // Indian numbering system
    });

    function toTitleCase(str) {
        return str
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    }

    const location = useLocation();
    const navigate = useNavigate();
    const invoiceNo = location?.state?.invoiceNo || "";
    const fromPath = location?.state?.from || "/";
    const tab = location?.state?.tab || "view";
    const [getBranch, setGetBranch] = useState([]);
    const [invoiceData, setGetInvoiceData] = useState({});
    const [getItem, setGetItem] = useState([]);
    const [getSumm, setGetSumm] = useState({});
    console.log(location.state);
    const [loading, setLoading] = useState(true);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    console.log(invoiceNo);

    const pageRef = useRef();
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getApi(`/GetFutureInvoiceById?InvoiceNo=${invoiceNo}`);
                setGetInvoiceData(response.data || {});
                setGetItem(response.data?.Items || []);
                setGetSumm(response.data?.GSTSummary || {});
            } catch (err) {
                console.error('Fetch Error:', err);
            } finally {
                setLoading(false);
                setIsDataLoaded(true);
                // generatePDF();
            }
        };
        if (invoiceNo) {
            fetchData();
        }
    }, [invoiceNo]);

const generatePDF = async () => {
    if (!pageRef.current) return;

    const tableDiv = pageRef.current.querySelector(".table-div");

    // Increase height only for PDF
    const originalHeight = tableDiv.style.minHeight;
    tableDiv.style.minHeight = "315px";

    await new Promise(resolve => setTimeout(resolve, 100));

    const opt = {
  margin: 0,
  filename: `${invoiceNo}.pdf`,

  image: {
    type: "jpeg",
    quality: 0.95,
  },

  html2canvas: {
    scale: 2.5,
    useCORS: true,
    backgroundColor: "#fff",
    logging: false,
  },

  jsPDF: {
    unit: "mm",
    format: "a4",
    orientation: "portrait",
  },

  pagebreak: {
    mode: [] // Disable automatic page breaks
  },
};

await html2pdf()
  .set(opt)
  .from(pageRef.current)
  .toPdf()
  .get("pdf")
  .then((pdf) => {
    // Remove any extra pages
    while (pdf.internal.getNumberOfPages() > 1) {
      pdf.deletePage(2);
    }
  })
  .save();


    // Restore original height
    tableDiv.style.minHeight = originalHeight;
};

    // if (loading) return <p>Loading...</p>;

    return (
        <>
            <style>
                {
                    `
                    
                    @media print 
                {
    body * {
        visibility: hidden;
    }

    #pdf, #pdf * {
        visibility: visible;
         -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    #pdf {
        position: absolute;
        left: 0;
        top: 0;
        width: auto !important;
        padding: 0 !important;
        margin: 0 !important;
        box-sizing: border-box;
    }

    button {
        display: none !important;
    }

   
}`
                }
            </style>


            <Header />
            <Sidebar1 />
            <div id="main-body">

                <div className="container-2" style={{ borderRadius: "0px", width: "770px",border:"none",marginTop:"5px"}}>

                    <div className="container-2" style={{ borderRadius: "0px", width: "770px", display: "flex", flexDirection: "row", border: "none", justifyContent: "end", gap: "10px", fontSize: "12px", alignItems: "center" }}>
                        <button
                            onClick={generatePDF}
                            style={{ padding: "5px 5px", borderRadius: "6px", background: "green", color: "white", border: "none", cursor: "pointer" }}
                        >
                            Download
                        </button>
                        <button
                            onClick={() => window.print()}
                            style={{ padding: "5px 10px", borderRadius: "6px", background: "red", color: "white", border: "none", cursor: "pointer" }}
                        >
                            Print
                        </button>
                        <button
                            onClick={() => navigate(fromPath, { state: { tab: tab } })}
                            style={{ padding: "5px 10px", borderRadius: "6px", background: "gray", color: "white", border: "none", cursor: "pointer" }}
                        >
                            Exit
                        </button>
                    </div>
                </div>

                <div className="container-2 invoice-page" ref={pageRef} id="pdf" style={{
                    borderRadius: "0px", paddingLeft: "20px", paddingRight: "20px", paddingTop: "20px"
                    , paddingBottom: "20px", width: "793px", direction: "flex",  fontFamily: "Arial, Helvetica, sans-serif",
                    flexDirection: "column", gap: "5px", fontSize: "10px", fontWeight: "bold", border: "none"
                }}>

                    <div className="container-2" style={{ borderRadius: "0px", border: "none", width: "750px", display: "flex", flexDirection: "column" }}>
                        < div id="printable-section" className="container-3" style={{ padding: "0px", border: "none" }}>
                            <div style={{ border: "2px solid #00499c", padding: "0px 20px" }}>

                                <div className="div1" style={{ display: "flex", flexDirection: "row", borderBottom: "1px solid gray", }}>
                                    <div style={{ width: "75%", display: "flex", gap: "7px" }}>
                                        <div style={{ width: "180px", height: "110px", padding: "10px", paddingTop: "10px", paddingBottom: "10px" }}>
                                            <img src={logoimg} alt="" style={{ height: "100%", width: "100%", }} />
                                        </div>
                                        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                            <div style={{ fontWeight: "bold", color: "#00499c", fontSize: "16px", marginTop: "12px" }}>FUTURE INFOSYS TECHNOLOIES</div>
                                            <div >FL-203 PL-243 SEC-R3 SHREE KRISHNA KRUPA PANVEL RAIGAD VADGHAR (CT),
                                                Navi Mumbai - 410206</div>

                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    fontSize: "10px",
                                                    gap: "0px",
                                                    width:"100%"
                                                    
                                                }}
                                            >
                                                {
                                                    [

                                                        {
                                                            no: <FaPhone />,
                                                            title:  "Contact Us",
                                                            width:"30%",
                                                            lines: ["+91 9987355637", "+91 8591892930"],
                                                        },
                                                        {
                                                            no: <IoMdMail />,
                                                            title: "Email",
                                                            width:"40%",
                                                            lines: ["account@futureinfosys.in", "cs@futureinfosys.in"],
                                                        },

                                                        {
                                                            no: <IoDocumentText />,
                                                            title: "GSTIN",
                                                            width:"30%",
                                                            lines: ["27HIQPS7651A1ZQ"],
                                                        },
                                                    ].map((item, index) => (
                                                        <div
                                                            key={index}
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "flex-start",
                                                                gap: "8px",
                                                                width: item.width,
                                                            }}
                                                        >
                                                            

                                                            <div>
                                                                <div
                                                                    style={{
                                                                        fontWeight: "bold",
                                                                        color: "#0b4ea2",
                                                                        marginBottom: "4px",
                                                                        display:"flex",
                                                                        gap:"5px",
                                                                        alignItems:"center",
                                                                    }}
                                                                >
                                                                    <div
                                                                style={{
                                                                    minWidth: "15px",
                                                                    height: "15px",
                                                                    borderRadius: "50%",
                                                                    background: "#0b4ea2",
                                                                    color: "#fff",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    fontSize: "8px",
                                                                }}
                                                            >
                                                                {item.no}
                                                            </div>
                                                                    <span>{item.title}</span> 
                                                                </div>

                                                                {item.lines.map((line, i) => (
                                                                    <div key={i} style={{ fontSize: "9px",lineHeight:"1" }}>
                                                                        {line}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ width: "25%", display: "flex", justifyContent: "end", }}>
                                        <div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                            <div style={{ fontSize: "18px", color: "#00499c", fontWeight: "bold" }}>TAX INVOICE</div>
                                            <div style={{ color: "#00499c", fontWeight: "bold" }}>#INV-{invoiceData.InvoiceNo}</div>
                                            <div>Date : <span>{invoiceData.InvoiceDate}</span></div>
                                        </div>
                                    </div>

                                </div>
                                <div className="div2" style={{ display: "flex", justifyContent: "space-between", marginTop: "5px", marginBottom: "10px", gap: "40px" }}>

                                    <div style={{ display: "flex", flex: 1, flexDirection: "column", gap: "2px" }}>
                                        <div style={{ fontSize: "12px" }}>BILL TO</div>
                                        <div style={{ fontSize: "13px", fontWeight: "bold", color: "#00499c", }}>{invoiceData?.CustomerName}</div>
                                        <div style={{ display: "flex", gap: "2px" }}>
                                            <div>{invoiceData?.CustomerAdd1},{invoiceData?.CustomerAdd2},{invoiceData?.CustomerAdd3},{invoiceData?.StateName}-{invoiceData?.PinCode}</div>
                                        </div>
                                        <div style={{ display: "flex", gap: "15px" }}>
                                            <div style={{ display: "flex", gap: "5px" }}>
                                                <div style={{ fontWeight: "bold" }}>City Name :</div>
                                                <div>{invoiceData.CityName}</div>
                                            </div>
                                            <div style={{ display: "flex", gap: "5px" }}>
                                                <div style={{ fontWeight: "bold" }}> State Name :</div>
                                                <div>{invoiceData.StateName}</div>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", gap: "15px" }}>
                                            <div style={{ display: "flex", gap: "5px" }}>
                                                <div style={{ fontWeight: "bold" }}>Mobile No :</div>
                                                <div>{invoiceData.CustomerMob} </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div style={{ display: "flex", width: "200px", flexDirection: "column", gap: "2px" }}>
                                        <div style={{ fontSize: "12px", visibility: "hidden" }}>*</div>
                                        <div style={{ display: "flex", gap: "5px", }}>
                                            <div style={{ fontWeight: "bold", width: "76px" }}>GST IN </div>
                                            <div style={{ fontWeight: "bold", }}>:</div>
                                            <div>{invoiceData.GstNo} </div>
                                        </div>
                                        <div style={{ display: "flex", gap: "5px" }}>
                                            
                                            <div style={{ fontWeight: "bold", width: "76px" }}>Payment Termms </div>
                                            <div style={{ fontWeight: "bold", }}>:</div>
                                            <div> 7 Days </div>
                                        </div>
                                        <div style={{ display: "flex", gap: "5px" }}>
                                            <div style={{ fontWeight: "bold", width: "76px" }}>Due Date </div>
                                            <div style={{ fontWeight: "bold", }}>:</div>
                                            <div> {invoiceData?.DueDate} </div>

                                        </div>



                                    </div>
                                </div>

                                <div className='table-div' style={{ minHeight: "220px", borderBottom: "1px solid gray" }}>
                                    <table style={{ width: "100%" }}>
                                        <thead>
                                            <tr style={{ background: "#daebff", color: "#00499c", padding: "5px" }}>
                                                <th style={{ padding: "5px", width: "60px" }}>Sr No.</th>
                                                <th style={{ padding: "5px", width: "800px" }}>Item Name</th>
                                                <th style={{ padding: "5px", width: "60px" }}>Qty</th>
                                                <th style={{ padding: "5px", width: "60px" }}>Rate</th>
                                                <th style={{ padding: "5px", width: "62px" }}>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ padding: "5px 0px" }}>

                                            {getItem?.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    style={{borderBottom:getItem.length-1===index ? "1px solid gray" : "none"}}
                                                >
                                                    <td
                                                        style={{
                                                            padding: "1px 5px",
                                                            width: "60px",
                                                            verticalAlign: "top",
                                                        }}
                                                    >
                                                        {index + 1}
                                                    </td>

                                                    <td style={{ padding: "1px 5px", width: "800px" }}>
                                                        {item.ItemDescription}
                                                    </td>

                                                    <td
                                                        style={{
                                                            padding: "1px 5px",
                                                            width: "60px",
                                                            verticalAlign: "top",
                                                        }}
                                                    >
                                                        {item.Qty}
                                                    </td>

                                                    <td
                                                        style={{
                                                            padding: "1px 5px",
                                                            verticalAlign: "top",
                                                        }}
                                                    >
                                                        {item.Rate}
                                                    </td>

                                                    <td
                                                        style={{
                                                            padding: "1px 5px",
                                                            verticalAlign: "top",
                                                            width: "62px"
                                                        }}
                                                    >
                                                        {item.Amount}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>



                                <div style={{ display: "flex", flexDirection: "column", alignItems: "end", padding: "5px 0px", borderBottom: "1px solid gray" }}>


                                    <div style={{ width: "148px", display: "flex", paddingBottom: "2px", }}>
                                        <span style={{ width: "66%" }}>
                                            Sub Total
                                        </span>
                                        <span style={{ flex: 1 }}>
                                            {getSumm?.SubTotal}
                                        </span>
                                    </div>
                                    <div style={{ width: "148px", display: "flex", paddingBottom: "2px" }}>
                                        <span style={{ width: "66%" }}>
                                            SGST ({getSumm?.SGST_Per}%)
                                        </span>
                                        <span style={{ flex: 1 }}>
                                            {getSumm?.SGST_Amount}
                                        </span>
                                    </div>
                                    
                                    <div style={{ width: "148px", display: "flex", paddingBottom: "2px" }}>
                                        <span style={{ width: "66%" }}>
                                            CGST ({getSumm?.CGST_Per}%)
                                        </span>
                                        <span style={{ flex: 1 }}>
                                            {getSumm?.CGST_Amount}
                                        </span>
                                    </div>
                                    <div style={{ width: "148px", display: "flex", paddingBottom: "2px" }}>
                                        <span style={{ width: "66%" }}>
                                            IGST ({getSumm?.IGST_Per}%)
                                        </span>
                                        <span style={{ flex: 1 }}>
                                            {getSumm?.IGST_Amount}
                                        </span>
                                    </div>
                                    <div style={{ display: "flex", width: "100%", borderTop: "1px solid gray", alignItems: "end", height: "20px" }}>
                                        <div style={{ flex: 1, display: "flex", fontWeight: "bold", alignItems: "center", fontSize: "11px" }}> <span style={{ color: "#00499c", marginRight: "5px" }}>Amount in Words :</span> {toTitleCase(
                                            toWords.convert(Number(getSumm?.GrandTotal || 0))
                                        )}</div>
                                        <div style={{ width: "148px", display: "flex", alignItems: "center" }}>
                                            <span style={{ width: "66%" }}>
                                                Total Amount
                                            </span>
                                            <span style={{ flex: 1 }}>
                                                {getSumm?.GrandTotal}
                                            </span>
                                        </div>
                                    </div>






                                </div>



                                {/* ======================= FOOTER ======================= */}

                                <div style={{ margin: "15px 0px", overflow: "hidden" }}>

                                    {/* Top Section */}
                                    <div style={{ display: "flex", marginBottom: "10px" }}>

                                        {/* Bank Details */}
                                        <div style={{ width: "33%", borderRight: "1px solid #ccc", paddingRight: "25px" }}>

                                            <div style={{
                                                background: "#0b4ea2",
                                                color: "#fff",
                                                padding: "5px",
                                                fontWeight: "bold",
                                                borderRadius: "5px",
                                                marginBottom: "10px",
                                                width: "120px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                gap: "10px"
                                            }}>
                                                <RiBankFill size={15} />
                                                <span>BANK DETAILS</span>
                                            </div>

                                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}><span style={{ width: "100px" }}><MdAccountBalance style={{ color: "#00499c", marginRight: "3px" }} /> Bank Name</span> <span style={{ width: "10px" }}>:</span>YES BANK Ltd</div>
                                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}><span style={{ width: "100px" }}><MdOutlineAccountCircle style={{ color: "#00499c", marginRight: "3px" }} /> Account Type</span> <span style={{ width: "10px" }}>:</span>Current Account</div>
                                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}><span style={{ width: "100px" }}><MdOutlineAccountCircle style={{ color: "#00499c", marginRight: "3px" }} /> Account Name</span> <span style={{ width: "10px" }}>:</span>KM SARITA</div>
                                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}><span style={{ width: "100px" }}><LuBanknote style={{ color: "#00499c", marginRight: "3px" }} /> Account Number </span><span style={{ width: "10px" }}>:</span>074061900003184</div>
                                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}><span style={{ width: "100px" }}><RiBankFill style={{ color: "#00499c", marginRight: "3px" }} /> IFSC Code</span> <span style={{ width: "10px" }}>:</span>YESB0000740</div>
                                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}><span style={{ width: "100px" }}><MdAccountBalance style={{ color: "#00499c", marginRight: "3px" }} /> Branch Name</span> <span style={{ width: "10px" }}>:</span>MAHAPE</div>
                                            <div style={{ display: "flex", alignItems: "center", width: "100%", marginTop: "5px", borderTop: "1px solid #00499c", paddingTop: "5px" }}><span style={{ width: "100px" }}><RiSecurePaymentFill style={{ color: "#00499c", marginRight: "3px" }} /> UPI ID</span> <span style={{ width: "10px" }}>:</span>futureinfosyso@oksbi</div>


                                            <div style={{
                                                marginTop: "15px",
                                                border: "1px solid #0b4ea2",
                                                padding: "5px",
                                                borderRadius: "5px",
                                                textAlign: "center",
                                                width: "170px",
                                                background: "#eaf4ff",
                                            }}>
                                                <b style={{ color: "#00499c" }}> <IoCheckmarkDoneCircle size={15} style={{ marginRight: "5px", color: "#00499c" }} /> PAYMENT INFORMATION</b>
                                                <br />
                                                Please make payment to the above account
                                                or scan QR code.
                                            </div>

                                        </div>

                                        {/* Scan */}
                                        <div style={{
                                            width: "25%",
                                            borderRight: "1px solid #ccc",
                                            textAlign: "center",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            gap: "0px"

                                        }}>

                                            <div style={{
                                                background: "green",
                                                color: "#fff",
                                                padding: "5px",
                                                fontWeight: "bold",
                                                borderRadius: "5px",
                                                marginBottom: "5px",
                                                width: "120px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "10px"
                                            }}>
                                                <BsQrCodeScan size={14} /> <span>SCAN & PAY</span>
                                            </div>

                                            <div style={{ color: "#00499c" }}>Scan to Pay using any UPI App</div>

                                            <div style={{
                                                height: "90px",
                                                width: "90px",
                                                margin: "5px auto",
                                                border: "2px solid green",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: "2px",
                                                borderRadius: "10px"
                                            }}>
                                                <img src={scan} alt="" style={{ width: "100%", height: "100%" }} />
                                            </div>

                                            <div style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: "0px 30px",
                                                marginTop: "5px"

                                            }}>
                                                <img src={UPI} alt="" style={{ width: "100%", height: "100%" }} />
                                            </div>


                                            <div style={{
                                                marginTop: "10px",
                                                background: "green",
                                                color: "#fff",
                                                padding: "2px 10px",
                                                borderRadius: "10px",
                                                fontWeight: "normal"
                                            }}>
                                                UPI ID : futureinfosyso@oksbi
                                            </div>

                                        </div>

                                        {/* Branch & Signature */}
                                        <div style={{
                                            width: "40%", display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                        }}>
                                            <div style={{
                                                background: "#0b4ea2",
                                                color: "#fff",
                                                padding: "5px",
                                                fontWeight: "bold",
                                                borderRadius: "5px",
                                                marginBottom: "10px",
                                                width: "250px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                gap: "10px"
                                            }}>
                                                <FaStamp size={15} />
                                                <span>FOR FUTURE INFOSYS TECHNOLOGIES</span>
                                            </div>



                                            <div style={{ display: "flex", width: "100%", gap: "5px", justifyContent: "space-between", marginTop: "15px" }}>
                                                <div style={{ width: "45%", display: "flex", flexDirection: "column", gap: "0px", alignItems: "center", justifyContent: "center" }}>
                                                    <div style={{
                                                        height: "90px",
                                                        width: "90px",
                                                        margin: "5px auto",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        

                                                    }}>
                                                        <img src={stamp} alt="" style={{ width: "100%", height: "100%" }} />
                                                    </div>
                                                    <div style={{
                                                        background: "#0b4ea2",
                                                        color: "#fff",
                                                        padding: "2px 5px",
                                                        fontWeight: "normal",
                                                        borderRadius: "5px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}>Compamny Stamp</div>
                                                </div>
                                                <div style={{ width: "1px", background: "red" }}></div>
                                                <div style={{

                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    width: "55%",
                                                    gap: "3px"



                                                }}>
                                                    <div style={{ height: "0.8px", background: "#0b4ea2", width: "100%", marginTop: "70px" }}>

                                                    </div>

                                                    <div style={{ color: "#0b4ea2" }}>AUTHORIZED SIGNATORY</div>

                                                    <div style={{ textAlign: "center" }}>For FUTURE INFOSYS TECHNOLOIES</div>

                                                    <div style={{ marginTop: "10px" }}>
                                                        Date: _______________________
                                                    </div>
                                                </div>
                                            </div>



                                        </div>

                                    </div>

                                    {/* Terms */}
                                    <div style={{
                                        border: "1px solid #0b4ea2",
                                        borderRadius: "5px",
                                        marginTop: "5px"
                                    }}>

                                        <div style={{
                                            background: "#0b4ea2",
                                            color: "#fff",
                                            padding: "4px",
                                            width: "150px",
                                            borderBottomRightRadius: "5px",
                                            fontWeight: "bold"
                                        }}>
                                            <FiFileText size={14} /> TERMS & CONDITIONS
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                border: "1px solid #b5b5b5",
                                                borderTop: "none",
                                                padding: "10px",
                                                lineHeight: "1.1",
                                            }}
                                        >
                                            {/* Left Column */}
                                            <div
                                                style={{
                                                    width: "50%",
                                                    paddingRight: "10px",
                                                    borderRight: "1px solid #cfcfcf",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "5px"
                                                }}
                                            >
                                                {[
                                                    "Payment is due within 7 days from the invoice date unless otherwise agreed.",
                                                    "Interest @18% per annum may be charged on overdue payments.",
                                                    "Goods once booked cannot be cancelled after dispatch.",
                                                    "The company shall not be liable for delays caused by natural calamities, strikes, customs, or circumstances beyond our control.",
                                                ].map((item, index) => (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "flex-start",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                minWidth: "12px",
                                                                height: "12px",
                                                                borderRadius: "50%",
                                                                background: "#0b4ea2",
                                                                color: "#fff",
                                                                fontWeight: "bold",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                marginRight: "10px",
                                                                fontSize: "8px"
                                                            }}
                                                        >
                                                            {index + 1}
                                                        </div>

                                                        <div>{item}</div>
                                                    </div>
                                                ))}
                                            </div>

                                            {/* Right Column */}
                                            <div
                                                style={{
                                                    width: "50%",
                                                    paddingLeft: "10px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "5px"
                                                }}
                                            >
                                                {[
                                                    "Any services or shortage must be reported within 24 hours of delivery.",
                                                    "Subject to Delhi Jurisdiction only.",
                                                    "This is a computer-generated invoice and does not require a physical signature.",
                                                ].map((item, index) => (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "flex-start",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                minWidth: "12px",
                                                                height: "12px",
                                                                borderRadius: "50%",
                                                                background: "#0b4ea2",
                                                                color: "#fff",
                                                                fontWeight: "bold",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                marginRight: "10px",
                                                                fontSize: "8px"
                                                            }}
                                                        >
                                                            {index + 5}
                                                        </div>

                                                        <div>{item}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                    </div>

                                    {/* Contact Footer */}



                                    {/* Thank You */}

                                    <div style={{
                                        background: "#0b4ea2",
                                        color: "#fff",
                                        textAlign: "center",
                                        padding: "0px",
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        fontStyle: "italic",
                                        borderRadius: "8px",
                                        marginTop:"15px"
                                    }}>
                                        Thank You For Choosing Future Infosys Technologies!
                                    </div>

                                </div>


                            </div>


                        </div>
                    </div >
                </div>
            </div >
        </>
    );
}

export default FutureInvoicePdf;